/* eslint-disable max-lines */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  LoginOAuth,
  LoginOAuthParams,
  OauthAEMConfig,
  SwapAuthForAccessTokens
} from '../../models';
import { ChallengeScreenError } from '../../security-verification/challenge-success.service';
import { UtilMethodsHelperSupportService } from './util-methods-helper-support.service';
@Injectable({
  providedIn: 'root'
})
export class UtilMethodsHelperService extends UtilMethodsHelperSupportService {
  isAuthErrorResponseHelperSupport(
    isAuthErrorCode: boolean,
    authResponseCode: string | undefined,
    isResourceNotFound: boolean
  ) {
    return !!(isAuthErrorCode || authResponseCode || isResourceNotFound);
  }

  isEamOutageCode(
    loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams,
    error: HttpErrorResponse
  ) {
    return (
      (loginAuthWithCredentialsParams.oauthConfig &&
        loginAuthWithCredentialsParams.oauthConfig
          .EAM_OUTAGE_ERROR_CODE_IGNORE &&
        loginAuthWithCredentialsParams.oauthConfig.EAM_OUTAGE_ERROR_CODE_IGNORE.filter(
          (code) => {
            return error?.status === parseInt(code);
          }
        ).length < 1) ||
      error.error.error
    );
  }

  isChallengeScreen(
    loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams,
    error: HttpErrorResponse | ChallengeScreenError
  ): boolean {
    return !!(
      ((error as { status?: number })?.status === 428 ||
        error instanceof ChallengeScreenError) &&
      loginAuthWithCredentialsParams?.oauthConfig?.ERROR_428
    );
  }

  splitUserMessageHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.error && authResponse.error.details
      ? authResponse.error.details[0].userMessage ?? ''
      : '';
  }

  checkErrorMessage(
    loginOAuthParams: LoginOAuthParams,
    error: HttpErrorResponse
  ): boolean {
    return (
      (loginOAuthParams?.oauthConfig?.EAM_OUTAGE_ERROR_CODE_IGNORE &&
        loginOAuthParams.oauthConfig.EAM_OUTAGE_ERROR_CODE_IGNORE.filter(
          (code) => {
            return error?.status === parseInt(code);
          }
        ).length < 1) ||
      error.error.error
    );
  }

  isRequestInputUniqueIdentifier(
    requestInput: ILoginUserNamePasswordInput | undefined,
    commonProperties: {
      oauthConfig: OauthAEMConfig;
      flowId: string | undefined;
      authId: string;
    },
    uniqueIdentifier: string,
    lastNameFormControlValueParam: string
  ) {
    return requestInput
      ? {
          ...commonProperties,
          fingerPrint: uniqueIdentifier,
          userNamePasswordFields: requestInput,
          lastNameFormControlValue: lastNameFormControlValueParam
        }
      : {
          ...commonProperties,
          fingerPrint: uniqueIdentifier
        };
  }

  getErrorDescriptionHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.error_description ?? '';
  }

  getAccessDeniedHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.code ?? 'access_denied';
  }

  getAuthResponseErrorObject(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.error ? authResponse.error.error ?? '' : '';
  }

  getAuthResponseArrayCode(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.errors ? authResponse.errors[0].code : '';
  }

  getAuthResponseErrorDetailsCode(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse.error &&
      authResponse.error.details &&
      authResponse?.error?.details[0].code
    );
  }
}
